import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  useTheme,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  platform: string;
  orderBy: string[];
  monitoredPlatforms: string[];
  onPlatformChange: (event: SelectChangeEvent) => void;
  onOrderByChange: (event: SelectChangeEvent<string[]>) => void;
}

const TrustpageFilterSort = ({
  platform,
  orderBy,
  monitoredPlatforms,
  onPlatformChange,
  onOrderByChange,
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: theme.spacing(2) }}>
      {monitoredPlatforms.length > 1 && (
        <FormControl
          sx={{ width: 200 }}
          size="small"
        >
          <InputLabel id="platform-select-label">{t('platform')}</InputLabel>
          <Select
            labelId="platform-select-label"
            value={platform}
            onChange={onPlatformChange}
            label={t('platform')}
          >
            <MenuItem value="">
              <em>-</em>
            </MenuItem>
            {monitoredPlatforms.map((platform, index) => {
              return (
                <MenuItem
                  key={index}
                  value={platform}
                >
                  {platform[0].toUpperCase() + platform.substring(1)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
      <FormControl
        sx={{ width: 200, ml: theme.spacing(1) }}
        size="small"
      >
        <InputLabel id="sort-select-label">{t('sort')}</InputLabel>
        <Select
          multiple
          labelId="sort-select-label"
          value={orderBy}
          input={<OutlinedInput label={t('sort')} />}
          onChange={onOrderByChange}
          label={t('sort')}
        >
          <MenuItem value="score asc">{t('score_asc')}</MenuItem>
          <MenuItem value="score desc">{t('score_desc')}</MenuItem>
          <MenuItem value="date asc">{t('date_asc')}</MenuItem>
          <MenuItem value="date desc">{t('date_desc')}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default TrustpageFilterSort;
